import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";

function UtilityHeader() {
  const history = useHistory();
  const [idNumber, setIdNumber] = useState();

  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      profileSearch();
    }
  };

  const profileSearch = async () => {
    history.push(`/facility/${idNumber}`);
  }

  return (
    <div className="utility-header">
      <div className="container">
        <Row className="group flex-row">
          <Col xs="12" md="6" className="social-media-links">
            <div className="header-cagov-logo">
              <a href="https://ca.gov">
                <span className="sr-only">CA.gov</span>
                <img
                  src="/images/Ca-Gov-Logo-Gold.svg"
                  className="pos-rel"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </div>
            <Link to="/" className="ca-gov-icon-home">
              <span className="sr-only">Home</span>
            </Link>
            <button className="btn btn-xs btn-primary">
              <a href="https://dtsc.ca.gov">Department of Toxic Substances Control</a>
            </button>
          </Col>
          <Col xs="12" md="6" className="settings-links">
            <span className="row ml-0 mr-1">
              <Form.Control
                placeholder="Go to ID Profile"
                aria-label="Go to ID Profile"
                type="text"
                value={idNumber}
                onChange={(e) => setIdNumber(e.target.value)}
                id="epaid"
                name="epaid"
                size="sm"
                onKeyDown={handleKeyDown}
                style={{ width: "150px", height: "calc(1.5em + 0.8rem)" }}
              />
              <Button
                type="button"
                variant="outline-secondary"
                size="sm"
                onClick={profileSearch}
                style={{
                  margin: 0, borderColor: "#ccc", height: "calc(1.5em + 0.8rem)", borderTopLeftRadius: 0, borderBottomLeftRadius: 0
                }}
              >
                <span className="ca-gov-icon-search formearch">
                  <span className="sr-only">Search</span>
                </span>
              </Button>
            </span>

            <Link to="/contact-us">
              <span
                className="ca-gov-icon-contact-us"
                aria-hidden="true"
              ></span>{" "}
              Contact Us
            </Link>
            <button
              className="btn btn-xs btn-primary"
              data-toggle="collapse"
              data-target="#siteSettings"
              aria-expanded="false"
              aria-controls="siteSettings"
            >
              <span className="ca-gov-icon-gear" aria-hidden="true"></span>{" "}
              Settings
            </button>
          </Col>
        </Row>
      </div>
    </div >
  );
}

export default UtilityHeader;
